/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { renderProgress } from "components/Form/FormField";

interface Props {
  user: any;
  // match: any; // use when we need it in returnComponent()
}

type optionsType = {
  regRequired?: boolean;
  loginRequired?: boolean;
};

export default (ChildComponent: any, options: optionsType = {}) => {
  const { regRequired, loginRequired } = {
    ...{ regRequired: true, loginRequired: true }, // default parameters
    ...options,
  };

  const RequireCheck: React.FC<Props> = (props: Props) => {
    const { user } = props;
    const returnComponent = () => {
      // We can check match.params/path to see if we need to redirect.

      // If user is allowed to view the page, we'll pass the props through. Note that:
      // If we have UX in this HOC with styles (means have classes), we should not pass the
      // classes here to the ChildComponent (since the 'classes' here is not implemented there).
      // We should strip out the classes in this way:
      //
      // const { classes, ...others } = this.props;
      // return <ChildComponent {...others} />;
      return <ChildComponent {...props} />;
    };

    switch (user) {
      case false:
        // not yet logged on, redirect to sign in page
        return loginRequired ? (
          <Redirect to="/signin" />
        ) : (
          <ChildComponent {...props} />
        );

      case null: // signing in, render preloader
        return renderProgress();

      default:
        if (regRequired && user && user.registered === false) {
          return <Redirect to="/prf/wel" />;
        }
        return returnComponent();
    }
  };

  function mapStateToProps(store: any) {
    return { user: store.state_auth };
  }

  return connect(mapStateToProps)(RequireCheck);
};
